export default __webpack_public_path__ + "static/whatIsBg-7ab0ad872bc0e7d4805350562c8c69e4.png";